import React, { Component } from "react";
import DatePicker from "../../components/datePicker/DatePicker";
import ModalBasiceVotingReport from "../component/ModalBasiceVotingReport";
import eVotingServices from "../../services/axiosServices/apiServices/eVotingServices";
import moment from "moment";
import { saveAs } from "file-saver";
import DashboardServices from "../../services/axiosServices/apiServices/DashboardServices";
import SwalServices from "../../services/swalServices/SwalServices";

export default class Report extends Component {
  constructor(props) {
    super(props);
    this.service = new eVotingServices();
    this.getDashboardServices = new DashboardServices();
    this.swalServices = new SwalServices();

    this.state = {
      dateFrom: "",
      dateTo: "",

      // modal states
      showLoginModal: false,
      showConfirmModal: false,

      // login fields
      loginPassword: "",
      loginValidationText: "",

      // confirm fields
      confirmPassword: "",
      confirmValidationText: "",

      // date validation
      dateValidationText: "",

      isSubmitting: false,

      candidateDetails: {
        //eVoting Details
        startDate: "",
        endDate: "",
        totalRegisteredVoters: 0,
        totalVotersSubmittedBallot: 0,
        totalVotersYetToSubmitBallot: 0
      }
    };
  }

  componentDidMount() {
    this.geteVotingAdminDashboardDetails();
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, loginValidationText: "", confirmValidationText: "", dateValidationText: "" });
  };

  handleDownload = (e) => {
    e.preventDefault();
    const { dateFrom, dateTo } = this.state;

    if (!dateFrom || !dateTo) {
      this.setState({ dateValidationText: "Please select both Date From and Date To." });
      return;
    }

    // open password modal
    this.setState({ showLoginModal: true, loginPassword: "", loginValidationText: "" });
  };

  geteVotingAdminDashboardDetails = () => {
    this.setState({ isLoading: true });
    this.getDashboardServices.geteVotingAdminDashboardDetails().then((response) => {
      if (response && response.statusCode === 200 && response.responseItem != null) {
        let responseData = response.responseItem.responseContent;
        this.setState({ candidateDetails: responseData });
      }
      this.setState({ isLoading: false });
    });
  };

  submitLogin = () => {
    const { loginPassword } = this.state;
    if (!loginPassword) {
      this.setState({ loginValidationText: "Please enter password." });
      return;
    }

    this.setState({ isSubmitting: true, loginValidationText: "" });
    const req = { Password: loginPassword, CheckConfirm: false };

    this.service.loginAdmin(req)
      .then((response) => {
        if (response && response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent != null) {
          const valid = response.responseItem.responseContent === "true";

          if (valid) {
            this.setState({ showLoginModal: false, showConfirmModal: true, confirmPassword: "", confirmValidationText: "" });
          } else {
            this.setState({ loginValidationText: "Invalid password." });
          }
        } else {
          this.setState({ loginValidationText: "Something went wrong. Please try again." });
        }
      })
      .catch((err) => {
        console.error('Login error', err);
        this.setState({ loginValidationText: "Error validating credentials." });
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  };

  submitConfirm = () => {
    const { confirmPassword } = this.state;
    if (!confirmPassword) {
      this.setState({ confirmValidationText: "Please enter confirm password." });
      return;
    }

    this.setState({ isSubmitting: true, confirmValidationText: "" });
    const req = { Password: confirmPassword, CheckConfirm: true };

    this.service.loginAdmin(req)
      .then((response) => {
        if (response && response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent != null) {
          const valid = response.responseItem.responseContent === "true";

          if (valid) {
            this.setState({ showConfirmModal: false }, () => {
              this.exportElectionResultsReport();
            });
          } else {
            this.setState({ confirmValidationText: "Confirm password did not match." });
          }
        } else {
          this.setState({ confirmValidationText: "Something went wrong. Please try again." });
        }
      })
      .catch((err) => {
        console.error('Confirm password error', err);
        this.setState({ confirmValidationText: "Something went wrong. Please try again." });
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  };

  exportElectionResultsReport = () => {
    if (this.state.dateFrom && this.state.dateTo) {
      this.setState({ isLoading: true });

      let request = {};
      request.fromDate = moment(this.state.dateFrom).format("DD MMM YYYY");
      request.toDate = moment(this.state.dateTo).format("DD MMM YYYY");
      const excelType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.service.exportElectionResultsReport(request).then((response) => {
        if (response.status === 200 && response.data != null) {
          if (response.data?.type === excelType) {
            let blob = new Blob([response.data])
            saveAs(blob, `VotingReport_${request.fromDate}_${request.toDate}.xlsx`);

            this.service.exportElectionVotedInReport(request).then((response2) => {
              if (response2.status === 200 && response2.data?.type === excelType) {
                saveAs(new Blob([response2.data]), `ElectionResults_External_${request.fromDate}_${request.toDate}.xlsx`);
                this.setState({ isLoading: false });
                this.swalServices.Success("Voting Reports Downloaded Successfully!");
              } else {
                this.setState({ isLoading: false });
                this.swalServices.Error("Second report could not be downloaded.");
              }
            });
          }
          else {
            this.setState({ isLoading: false });
            this.swalServices.Error("No records available between these dates.");
          }
        }
        else {
          this.swalServices.Error(response.message);
          this.setState({ isLoading: false });
        }
      });
    }
  }

  render() {
    const { dateFrom, dateTo, dateValidationText, showLoginModal, showConfirmModal, loginPassword, loginValidationText, confirmPassword, confirmValidationText, isSubmitting } = this.state;

    return (
      <div className="main-body-section">
        <div className="bg-white rounded-sm shadow-md">
          <div className="heading-part px-7 py-4 border-b flex items-center justify-between">
            <h4 className="small-title font-bold theme-color text-2xl">Report</h4>
          </div>
          <div className="px-7 py-4 pt-10">
            {/* Header info */}
            <div className="mb-8 p-4 bg-blue-50/50 border border-blue-100 rounded text-lg text-slate-700 font-medium">
              There are <span className="font-bold text-[#C00000]">{this.state.candidateDetails.totalVotersSubmittedBallot}</span> candidates who have voted.
            </div>

            {/* Download section */}
            <div className="mb-8 border border-gray-200 p-6 rounded bg-gray-50/50">
              <h5 className="text-xl font-bold mb-6 theme-color border-b pb-2">Download Report</h5>

              <div className="grid grid-cols-12 gap-6 items-center">
                {/* Date From */}
                <div className="col-span-12 md:col-span-5 mb-4">
                  <label className="filter-lable block font-medium mb-3 theme-color min-h-30">Date From <span className="text-[#C00000]">*</span></label>
                  <DatePicker name="dateFrom" value={dateFrom} handleChange={this.handleChange} />
                </div>

                {/* "To" Separator */}
                <div className="col-span-12 md:col-span-2 mb-4 text-center font-bold text-gray-500 pt-8 text-xl">To</div>

                {/* Date To */}
                <div className="col-span-12 md:col-span-5 mb-4">
                  <label className="filter-lable block font-medium mb-3 theme-color min-h-30">Date To <span className="text-[#C00000]">*</span></label>
                  <DatePicker name="dateTo" value={dateTo} handleChange={this.handleChange} minDate={dateFrom} />
                </div>

                {dateValidationText ? (
                  <div className="col-span-12 text-red-600 font-medium">{dateValidationText}</div>
                ) : null}
              </div>
            </div>

            {/* Download Button */}
            <div className="flex justify-start pt-6 border-t">
              <button type="button" onClick={this.handleDownload} className="btn btn-red text-white py-3 px-8 text-lg font-semibold rounded-none tracking-normal">Download</button>
            </div>
          </div>
        </div>

        {/* Login Modal: Password */}
        <ModalBasiceVotingReport id="login-modal" modalOpen={showLoginModal} setModalOpen={(v) => this.setState({ showLoginModal: v })}>
          <div className="px-7 py-6 sm:px-8">
            <div className="mb-6">
              <p className="text-xs font-semibold text-red-600 mb-4">STEP 1 OF 2</p>
              <h2 className="text-2xl font-bold text-slate-900 mb-3">Enter Admin Password 1</h2>
              <p className="text-lg leading-6 text-slate-500">Verify your first administrator credentials to continue downloading the report.</p>
            </div>
            <div className="mb-5">
              <label htmlFor="login-password" className="mb-2 block text-sm font-semibold text-slate-700">Password 1</label>
              <input id="login-password" name="loginPassword" type="password" value={loginPassword} onChange={this.handleChange} autoComplete="current-password" autoFocus placeholder="Enter password" className="input w-full rounded-md border border-slate-300 px-4 py-2.5 shadow-sm focus:border-indigo-500 focus:ring-indigo-500" />
            </div>
            {loginValidationText ? <div role="alert" className="mb-5 rounded-md border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-700">{loginValidationText}</div> : null}
            <div className="flex items-center justify-between border-t border-slate-100 pt-5">
              <button type="button" className="btn btn-secondary border !rounded-md border-slate-300 px-5" onClick={() => this.setState({ showLoginModal: false })} disabled={isSubmitting}>Back</button>
              <div className="flex gap-3">
                <button type="button" className="btn btn-secondary border !rounded-md border-slate-300 px-5" onClick={() => this.setState({ showLoginModal: false })} disabled={isSubmitting}>Cancel</button>
                <button type="button" className="btn btn-red text-white text-lg font-semibold !rounded-md tracking-normal disabled:cursor-not-allowed disabled:opacity-60" onClick={this.submitLogin} disabled={isSubmitting}>{isSubmitting ? "Verifying..." : "Continue"}</button>
              </div>
            </div>
          </div>
        </ModalBasiceVotingReport>

        {/* Confirm Modal: Confirm Password */}
        <ModalBasiceVotingReport id="confirm-modal" noCloseIcon={true} modalOpen={showConfirmModal} setModalOpen={(v) => this.setState({ showConfirmModal: v })}>
          <div className="px-7 py-6 sm:px-8">
            <div className="mb-6">
              <p className="text-xs font-semibold text-red-600 mb-4">STEP 2 OF 2</p>
              <h2 className="text-2xl font-bold text-slate-900 mb-3">Enter Admin Password 2</h2>
              <p className="text-lg leading-6 text-slate-500">Verify your second administrator credentials to continue downloading the report.</p>
            </div>
            <div className="mb-5">
              <label htmlFor="confirm-password" className="mb-2 block text-sm font-semibold text-slate-700">Confirm password 2</label>
              <input id="confirm-password" name="confirmPassword" type="password" value={confirmPassword} onChange={this.handleChange} autoComplete="current-password" autoFocus placeholder="Enter second password" className="input w-full rounded-md border border-slate-300 px-4 py-2.5 shadow-sm focus:border-indigo-500 focus:ring-indigo-500" />
            </div>
            {confirmValidationText ? <div role="alert" className="mb-5 rounded-md border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-700">{confirmValidationText}</div> : null}
            <div className="flex items-center justify-between border-t border-slate-100 pt-5">
              <button type="button" className="btn btn-secondary border border-slate-300 !rounded-md px-5" onClick={() => this.setState({ showConfirmModal: false })} disabled={isSubmitting}>Back</button>
              <div className="flex gap-3">
                <button type="button" className="btn btn-secondary border border-slate-300 !rounded-md px-5" onClick={() => this.setState({ showConfirmModal: false })} disabled={isSubmitting}>Cancel</button>
                <button type="button" className="btn btn-red text-white text-lg font-semibold !rounded-md disabled:cursor-not-allowed disabled:opacity-60" onClick={this.submitConfirm} disabled={isSubmitting}>{isSubmitting ? "Confirming..." : "Confirm & Download"}</button>
              </div>
            </div>
          </div>
        </ModalBasiceVotingReport>

      </div>
    );
  }
}
